module.exports = __webpack_public_path__ + "static/media/d4kz.b1188b93.pdf";